export const packagesData = [
  {
    id: "microneedling-facial-4-sessions",
    name: "Microneedling Facial",
    sessions: 4,
    price: 420,
    rrp: 480,
  },
  {
    id: "microneedling-facial-6-sessions",
    name: "Microneedling Facial",
    sessions: 6,
    price: 600,
    rrp: 720,
  },
];
